'use client'

import Link from 'next/link'
import Image from 'next/image'
import { useState, useEffect } from 'react'

const HOME_URL = process.env.NEXT_PUBLIC_BASE_URL_WITH_WWW || '/'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const navItems = [
    { href: '/#einfache-loesungen', label: 'Lösungen' },
    { href: '/#welche-fahrzeuge-uebernimmt', label: 'Fahrzeuge' },
    { href: '/#transparente-preisgestaltung', label: 'Preise' },
    { href: '/impressum', label: 'Impressum' },

  ]

  return (
    <header className={`sticky top-0 z-40 transition-shadow ${isScrolled ? 'shadow-lg bg-primary' : 'bg-primary'} duration-300`}>
      <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <Link href={HOME_URL} className="flex items-center gap-3 group" onClick={closeMenu}>
          <div className="rounded-full p-2 flex items-center justify-center shadow-md bg-primary-light">
            <Image
              src="/images/logo.png"
              alt="Autoverwertung Erkelenz Logo"
              width={48}
              height={48}
              priority
              className="h-10 w-10 object-contain"
            />
          </div>
          <span className="text-lg font-extrabold text-white tracking-wide group-hover:text-primary-light transition-colors">Autoverwertung Erkelenz</span>
        </Link>

        <button
          className={`lg:hidden flex flex-col justify-center items-center w-10 h-10 rounded text-white bg-primary-light shadow-md transition-all duration-300  ${isMenuOpen ? 'ring-2 ring-primary-dark' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-1 bg-white rounded mb-1 transition-transform duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-1 bg-white rounded mb-1 transition-opacity duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-1 bg-white rounded transition-transform duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex flex-row flex-wrap items-center gap-3 overflow-x-auto">
          {navItems.map(item => (
            <Link
              key={item.href}
              href={item.href}
              className="nav-link whitespace-nowrap px-3 py-2 rounded text-white text-sm font-semibold hover:bg-primary-light hover:text-primary-dark transition-colors duration-200"
              onClick={closeMenu}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Mobile Nav Panel */}
        {isMenuOpen && (
          <div
            className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-40 lg:hidden"
            onClick={closeMenu}
            aria-label="Close menu overlay"
          >
            <nav
              className="w-64 h-full bg-primary-dark flex flex-col gap-4 p-6 shadow-xl animate-slideIn"
              onClick={e => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
            >
              <button
                className="self-end mb-4 text-white bg-primary-light rounded-full w-8 h-8 flex items-center justify-center shadow-md"
                onClick={closeMenu}
                aria-label="Close menu"
              >
                <span className="text-xl font-bold">×</span>
              </button>
              {navItems.map(item => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="nav-link px-4 py-3 rounded text-white font-semibold hover:bg-primary-light hover:text-primary-dark transition-colors duration-200 text-lg"
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
      {/* Add slideIn animation */}
      <style jsx>{`
        @keyframes slideIn {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slideIn {
          animation: slideIn 0.3s cubic-bezier(0.4,0,0.2,1);
        }
      `}</style>
    </header>
  )
}

